import { useRef, useEffect, useCallback } from 'react';

const useDebouncedCallback = (callback: () => void, delay: number) => {
  const timeoutRef = useRef<ReturnType<typeof setTimeout>>();

  const debouncedFunction = useCallback(() => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    timeoutRef.current = setTimeout(() => {
      callback();
    }, delay);
  }, [callback, delay]);

  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  return debouncedFunction;
};

export default useDebouncedCallback;
